export default __webpack_public_path__ + "static/media/projectImg.e5d14d3a.png";